import { createContext } from 'react'

import { ProgressContextType } from './ProgressContext.types'

export const ProgressContext = createContext<ProgressContextType | undefined>(
  undefined
)
